import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import DeduccOSalidasForm from './fideicomisonoempresarial/DeduccOSalidasForm';
import IngresosOEntradasForm from './fideicomisonoempresarial/IngresosOEntradasForm';
import RetEfectFideicomisoForm from './fideicomisonoempresarial/RetEfectFideicomisoForm';

const initialSteps = {
  base: false,
};

const initialFormValidation = {
  isValidIngresosOEntradas: false,
  isValidDeduccOSalidas: false,
  isValidRetEfectFideicomiso: false,
};

const ComplementoFideicomisoNoEmpresarial = (props) => {
  const [data, setData] = useState({});
  const [steps, setSteps] = useState(initialSteps);
  const [formValidation, setFormValidation] = useState(initialFormValidation);

  useEffect(() => {
    if (props.data) {
      setData({ ...props.data });
      setSteps({
        base: true,
      });
      setFormValidation({
        isValidIngresosOEntradas: true,
        isValidDeduccOSalidas: true,
        isValidRetEfectFideicomiso: true,
      });
    }

    return () => {};
  }, [props.data]);

  const handleOnIngresoOEntradasChange = (event, metadata) => {
    const newData = {
      ...data,
      IngresosOEntradas: {
        ...data.IngresosOEntradas,
        ...event,
      },
    };

    if (metadata.step) {
      setSteps({
        ...steps,
        [metadata.step]: metadata.isValid,
      });
    }

    setFormValidation({
      ...formValidation,
      [metadata.name]: metadata.isValid,
    });

    setData(newData);
  };

  const handleOnDeduccOSalidasChange = (event, metadata) => {
    const newData = {
      ...data,
      DeduccOSalidas: {
        ...data.DeduccOSalidas,
        ...event,
      },
    };

    if (metadata.step) {
      setSteps({
        ...steps,
        [metadata.step]: metadata.isValid,
      });
    }

    setFormValidation({
      ...formValidation,
      [metadata.name]: metadata.isValid,
    });

    setData(newData);
  };

  const handleOnRetEfectFideicomisoChange = (event, metadata) => {
    const newData = {
      ...data,
      RetEfectFideicomiso: {
        ...data.RetEfectFideicomiso,
        ...event,
      },
    };

    if (metadata.step) {
      setSteps({
        ...steps,
        [metadata.step]: metadata.isValid,
      });
    }

    setFormValidation({
      ...formValidation,
      [metadata.name]: metadata.isValid,
    });

    setData(newData);
  };

  const handleOnComplementoAdd = () => {
    const Fideicomisonoempresarial = {
      ...data,
      Version: '1.0',
    };

    props.onChange({ Fideicomisonoempresarial });

    clearData();
  };

  const handleOutForm = () => {
    props.onCancel();
  };

  const clearData = () => {
    setData({});
  };

  const isValidAllForms = () => {
    let isValid = false;

    for (const key in formValidation) {
      if (Object.prototype.hasOwnProperty.call(formValidation, key)) {
        if (formValidation[key] === false) {
          isValid = false;

          break;
        }

        isValid = formValidation[key] ?? false;
      }
    }

    return isValid;
  };

  return (
    <>
      <Row>
        <Col>
          <h5 className="text-right">Fideicomiso No Empresarial</h5>
        </Col>
      </Row>

      <div className="pb-4">
        <div className="pb-4">
          <strong className="text-black text-upper">Ingresos obtenidos</strong>
        </div>

        <IngresosOEntradasForm
          data={data.IngresosOEntradas || {}}
          onFormDataChange={handleOnIngresoOEntradasChange}
        />
      </div>

      <div className="pb-4">
        <div className="pb-4">
          <strong className="text-black text-upper">Egresos obtenidos</strong>
        </div>

        <DeduccOSalidasForm
          data={data.DeduccOSalidas || {}}
          onFormDataChange={handleOnDeduccOSalidasChange}
        />
      </div>

      <div className="pb-4">
        <div className="pb-4">
          <strong className="text-black text-upper">Retenciones efectuadas</strong>
        </div>

        <RetEfectFideicomisoForm
          data={data.RetEfectFideicomiso || {}}
          onFormDataChange={handleOnRetEfectFideicomisoChange}
        />
      </div>
      <Row>
        <Col>
          <Button
            variant="secondary"
            className="mr-2"
            onClick={handleOutForm}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            disabled={!isValidAllForms()}
            onClick={handleOnComplementoAdd}
          >
            Agregar complemento
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ComplementoFideicomisoNoEmpresarial;
